import { cn } from '@/lib/utils';
import { BigDecimal, formatNumber } from '@/utils/value-format';

interface PnLProps {
  pnl: BigDecimal;
  roePct: BigDecimal;
}

export default function PnL({ pnl, roePct }: PnLProps) {
  return (
    <div
      className={cn(
        'opacity-100',
        pnl.bigint < 0n && 'text-red',
        pnl.bigint > 0n && 'text-green',
      )}
    >
      {formatNumber(pnl.decimal, {
        digits: 2,
        showChange: true,
        style: 'currency',
      })}{' '}
      /{' '}
      {formatNumber(roePct.decimal, {
        digits: 2,
        style: 'percent',
        abs: true,
      })}
    </div>
  );
}
